import { observer } from 'mobx-react-lite';
import modalStore, { ModalOption } from '../../../stores/modalStore';
import StockModalBasicInfo from '../../stock/StockModalBasicInfo';
import StockModalPriceInfo from '../../stock/StockModalPriceInfo';
import Carousel, { useCarouselContext } from '../Carousel';
import { Modal } from './Modal';
import { useCommonNavigate } from '../CommonLink';

/**
 * StockModalContent - 캐러셀 슬라이드 내용
 * - CarouselProvider context 내부에서 실행되어야 함
 */
const StockModalContent = observer(({ ticker }: { ticker: string }) => {
    const { carouselStore } = useCarouselContext();
    const isPriceSlideActive = carouselStore.currentSlideIndex === 1;

    return (
        <Modal.ModalCarouselContainer>
            <Carousel.Slide className="px-5">
                <StockModalBasicInfo ticker={ticker} />
            </Carousel.Slide>
            <Carousel.Slide className="px-5">
                <StockModalPriceInfo ticker={ticker} disableFetch={!isPriceSlideActive} />
            </Carousel.Slide>
        </Modal.ModalCarouselContainer>
    );
});

/**
 * 주식 정보 모달
 * - 캐러셀 형태로 기본 정보와 가격 정보를 슬라이드로 제공
 * - Modal.BodyCarousel을 사용하여 캐러셀 레이아웃 구성
 */
const StockModal = observer(({ modalId, option }: { modalId: string; option: ModalOption }) => {
    const ticker = option.stock?.ticker;
    const { navigate } = useCommonNavigate();

    if (!ticker) {
        return null;
    }

    return (
        <Modal.Dialog modalId={modalId}>
            <Modal.ModalCarousel>
                <StockModalContent ticker={ticker} />
            </Modal.ModalCarousel>
            <div className="mt-5 px-5">
                <button
                    className="btn btn-soft btn-block"
                    onClick={async (e) => {
                        e.preventDefault();
                        navigate(`/stock/${ticker}`);
                        await modalStore.close(modalId);
                    }}
                >
                    자세히 보기
                </button>
            </div>
        </Modal.Dialog>
    );
});

export default StockModal;
